function i(r, t) {
  for (var e = -1, a = Array(r); ++e < r; )
    a[e] = t(e);
  return a;
}
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseTimes.js
// module id = 1449
// module chunks = 41